import { render, staticRenderFns } from "./ContestCloneComponent.vue?vue&type=template&id=4270af7b"
import script from "./ContestCloneComponent.vue?vue&type=script&lang=js"
export * from "./ContestCloneComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports